namespace $ {
	export class $shm_hitalama_map_transfer_widget extends $mol_object {
		
		static async image_blob_uri_async( widget: $shm_hitalama_map_widget ) {
			const blob = widget.Image()?.blob()
			if( !blob ) return
			const uri = await $mol_blob_uri( blob )
			return uri
		}

		@ $mol_action
		static serialize( widget: $shm_hitalama_map_widget ) {
			const image_blob_uri = this.$.$mol_wire_sync(this).image_blob_uri_async( widget )
			const chart = widget.Chart()?.remote()

			return {
				ref: widget.link().toString(),

				title: widget.title(),
				
				body_x: widget.body_x(),
				body_y: widget.body_y(),
				bottom_edge_y: widget.bottom_edge_y(),
				right_edge_x: widget.right_edge_x(),
				top_edge_y: widget.Top_edge_y()?.val(),
				left_edge_x: widget.Left_edge_x()?.val(),
				opacity: widget.opacity(),
				type: widget.type(),

				type_custom: widget.Type_custom()?.remote()?.link().toString(),
		
				/** customizer */
				custom: widget.Custom()?.remote()?.link().toString(),

				// Map: $giper_baza_atom_link.to( ()=> $shm_hitalama_map ),
		
				image_blob_uri,
				color: widget.Color()?.val(),
				font_size: widget.Font_size()?.val(),
				border_color: widget.Border_color()?.val(),
				border_opacity: widget.Border_opacity()?.val(),
				border_width: widget.Border_width()?.val(),
				border_style: widget.Border_style()?.val(),

				/** text|code|customdom */
				text: widget.text(),
				link_to_viewport: widget.link_to_viewport(),

				enabled: widget.enabled(),

				/** ai_request */
				ai_request_type: widget.Ai_request()?.remote()?.request_type(),
				ai_request_parent_id: widget.Ai_request()?.remote()?.parent_id(),
				ai_request_obj: widget.Ai_request()?.remote()?.obj(),

				/** component */
				component: widget.Component()?.remote()?.data(),

				/** code_sql */
				sql: widget.Code_sql()?.remote()?.sql(),

				/** viewport_frame */
				viewport_frame_ratio: widget.type() == 'viewport_frame'
					? widget.viewport_frame().ratio()
					: undefined,

				/** form */
				form_link: widget.Form()?.remote()?.link().toString(),

				/** form_custom */
				form_custom_use_for_fields_link: widget.Form_custom()?.remote()?.Use_for_fields()?.remote()?.link().toString(),
				form_custom_object_current: widget.Form_custom()?.remote()?.object_current(),
				form_custom_objects: widget.Form_custom()?.remote()?.objects(),
				form_custom_hide_buttons: widget.Form_custom()?.remote()?.hide_buttons(),
				
				use_text_from_link: widget.Use_text_from()?.remote()?.link().toString(),
				
				/** form_edit */
				form_edit_link: widget.Form_edit()?.remote()?.link().toString(),

				/** table|chart */
				table_link: widget.Table()?.remote()?.link().toString(),

				/** chart */
				chart: chart ? $shm_hitalama_map_transfer_chart.serialize( chart ) : undefined,

				/** file */
				file_link: widget.File()?.remote()?.link().toString(),
			}
		}

		@ $mol_action
		static deserialize_data( widget: $shm_hitalama_map_widget, dto: ReturnType< typeof $shm_hitalama_map_transfer_widget['serialize'] > ) {

			widget.title( dto.title == dto.ref ? widget.link().toString() : dto.title )
			if( dto.body_x !== undefined ) widget.body_x( dto.body_x )
			if( dto.body_y !== undefined ) widget.body_y( dto.body_y )
			if( dto.bottom_edge_y !== undefined ) widget.bottom_edge_y( dto.bottom_edge_y )
			if( dto.right_edge_x !== undefined ) widget.right_edge_x( dto.right_edge_x )
			widget.Top_edge_y( dto.top_edge_y )?.val( dto.top_edge_y )
			widget.Left_edge_x( dto.left_edge_x )?.val( dto.left_edge_x )
			if( dto.opacity !== undefined ) widget.opacity( dto.opacity )
			if( dto.type !== undefined ) widget.type( dto.type! )
			widget.Color( null )?.val( dto.color )
			widget.Font_size( null )?.val( dto.font_size )
			widget.Border_color( null )?.val( dto.border_color )
			widget.Border_opacity( null )?.val( dto.border_opacity )
			widget.Border_width( null )?.val( dto.border_width )
			widget.Border_style( null )?.val( dto.border_style )
			widget.text( dto.text?.replaceAll('board','map') )
			widget.link_to_viewport( dto.link_to_viewport )
			widget.enabled( dto.enabled )

			if( dto.chart ) {
				const chart = widget.chart()
				chart?.Widget(null)?.remote( widget )
				$shm_hitalama_map_transfer_chart.deserialize( chart!, dto.chart )
			}
			if( dto.ai_request_type ) {
				widget.ai_request().request_type( dto.ai_request_type )
			}
			if( dto.ai_request_obj ) {
				widget.ai_request().obj( dto.ai_request_obj )
			}
			if( dto.component ) {
				widget.component().data( dto.component )
			}
			if( dto.form_custom_object_current ) {
				widget.form_custom().object_current( dto.form_custom_object_current )
			}
			if( dto.form_custom_objects ) {
				widget.form_custom().objects( dto.form_custom_objects )
			}
			if( dto.form_custom_hide_buttons !== undefined ) {
				widget.form_custom().hide_buttons( dto.form_custom_hide_buttons )
			}
			if( dto.viewport_frame_ratio !== undefined ) {
				widget.viewport_frame().ratio( dto.viewport_frame_ratio )
			}
			
			if( dto.image_blob_uri ) {
				const blob = this.$.$mol_wire_sync(this.$.$mol_fetch).blob( dto.image_blob_uri )
				widget.Image(null)!.blob( blob )
			}
		}

		@ $mol_action
		static deserialize_links( widget: $shm_hitalama_map_widget, dto: ReturnType< typeof $shm_hitalama_map_transfer_widget['serialize'] >, ref_remap: (ref: string)=> string ) {
			const dto_old = dto as typeof dto & {
				use_chart_from_link?: string
				use_chart_from_ref?: string
				use_text_from_ref?: string
				table_ref?: string
				file_ref?: string
				form_edit_ref?: string
				form_ref?: string
				sql?: string
				ai_request_parent_id?: string
				form_custom_use_for_fields_link?: string
			}

			if( dto.type_custom ) {
				const custom = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( dto.type_custom )! ), $shm_hitalama_map_widget_entity_custom )
				widget.Type_custom(null)?.remote( custom )
			}
			if( dto.custom ) {
				const custom = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( dto.custom )! ), $shm_hitalama_map_widget_entity_custom )
				widget.Custom(null)?.remote( custom )
			}
			const use_chart_from = dto_old.use_chart_from_link ?? dto_old.use_chart_from_ref
			if( use_chart_from ) {
				const use_from = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( use_chart_from )! ), $shm_hitalama_map_widget )
				const chart = use_from.chart()
				if( chart ) widget.Chart(null)?.remote( chart )
			}
			if( dto_old.sql ) {
				widget.code_sql().sql( dto_old.sql )
			}
			if( dto_old.ai_request_parent_id ) {
				widget.ai_request().parent_id( ref_remap( dto_old.ai_request_parent_id )! )
			}
			const use_text_from = dto.use_text_from_link ?? dto_old.use_text_from_ref
			if( use_text_from ) {
				const use_from = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( use_text_from )! ), $shm_hitalama_map_widget )
				widget.Use_text_from(null)?.remote( use_from )
			}
			const form_link = dto.form_link ?? dto_old.form_ref
			if( form_link ) {
				const form = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( form_link )! ), $shm_hitalama_map_widget_entity_form )
				widget.Form(null)?.remote( form )
			}
			if( dto_old.form_custom_use_for_fields_link ) {
				const use_for_fields = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( dto_old.form_custom_use_for_fields_link )! ), $shm_hitalama_map_widget )
				widget.form_custom().Use_for_fields(null)?.remote( use_for_fields )
			}
			const table_link = dto.table_link ?? dto_old.table_ref
			if( table_link ) {
				const table = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( table_link )! ), $shm_hitalama_map_widget_entity_table )
				widget.Table(null)?.remote( table )
			}
			const file_link = dto.file_link ?? dto_old.file_ref
			if( file_link ) {
				const file = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( file_link )! ), $shm_hitalama_file )
				widget.File(null)?.remote( file )
			}
			const form_edit_link = dto.form_edit_link ?? dto_old.form_edit_ref
			if( form_edit_link ) {
				const form = $giper_baza_glob.Pawn( new $giper_baza_link( ref_remap( form_edit_link )! ), $shm_hitalama_map_widget_entity_form )
				widget.Form_edit(null)?.remote( form )
			}
		}
		
	}
}
